var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"txn-wrap"},[_c('div',{staticClass:"line-chart",attrs:{"id":"tx-trend"}})])
}]

export { render, staticRenderFns }